<template>
    <div class="question-wrap">
        <v-layout justify-space-between align-center mb-4
                  :class="{'px-3': $vuetify.breakpoint.smAndDown}"
        >
            <v-flex class="xs7 sm8 display-1 font-weight-bold">{{ $t("Итоговое тестирование") }}</v-flex>
            <v-layout v-if="time_test > 0 && (test_remain_in_seconds || timer_started) && !resultsLayout" column class="align-end">
                <div class="grey-text text-xs-right" :class="{'caption': $vuetify.breakpoint.xs}">{{ $t("Осталось времени") }}</div>
                <div class="red-text mt-1" :class="{'title': $vuetify.breakpoint.xs, 'headline': $vuetify.breakpoint.smAndUp}">
                    <Timer />
                </div>
            </v-layout>
        </v-layout>
        <v-layout row wrap>
            <div v-for="i in questions.length"
                 :id="i"
                 :key="i"
                 class="question-num"
                 :class="{'active': i==question_number+1, 'correct': resultsLayout && if_correct(i-1), 'wrong': resultsLayout && !if_correct(i-1)}"
                 @click="resultsLayout ? TO_QUESTION(i-1) : null"
            >{{ i }}</div>

        </v-layout>
        <questionBlock v-if="!resultsLayout" />
        <resultQuestionBlock v-else />
    </div>
</template>

<script>
import questionBlock from './question_block';
import resultQuestionBlock from './result_question_block';
import {mapGetters, mapMutations} from 'vuex';
import Timer from './timer/timer';
export default {
  components: {
    questionBlock,
    resultQuestionBlock,
    Timer,
  },
  computed: {
    ...mapGetters('testing/questions', [
      'question_number',
      'questions',
      'question_by_number',
      'questions_length',
      'stats',
      'test_history',
    ]),
    ...mapGetters('testing', [
      'resultsLayout',
      'passed_seconds',
      'timer_started',
    ]),
    ...mapGetters('course_info', [
      'test_started',
      'time_test',
      'test_remain_in_seconds',
    ]),
    ...mapGetters('course_info/content', [
      'course_id',
    ]),
  },
  methods: {
    ...mapMutations('testing/questions', [
      'TO_QUESTION',
    ]),
    if_correct(i) {
      let question = this.test_history.find((item)=>item.question_id==this.questions[i].id);
      if (question) {
        return question.success_answer;
      }
    },
  },
};
</script>
<style lang="less" >
.question-num {
  cursor:auto;
}
.question-num:hover{
  background-color: white!important;
  color: #4a4a4a!important;
}
.correct, .wrong {
  cursor: pointer;
}
</style>


